const STATS = [
  { value: "4 × 750 W", label: "Independent hub motors" },
  { value: "35°", label: "Max climbing gradient" },
  { value: "250 mm", label: "Ground clearance" },
  { value: "190 kg", label: "Max user weight" },
];

export default function StatsBar() {
  return (
    <section data-testid="stats-bar" className="bg-foreground text-background border-y border-foreground">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 grid grid-cols-2 md:grid-cols-4">
        {STATS.map((s, i) => (
          <div
            key={s.label}
            className={`py-8 md:py-10 ${i !== 0 ? "md:border-l border-background/15" : ""} ${
              i % 2 === 1 ? "border-l border-background/15 md:border-l" : ""
            }`}
          >
            <div className="font-display text-3xl md:text-5xl font-black tracking-tight text-primary">
              {s.value}
            </div>
            <div className="mt-2 text-[11px] uppercase tracking-[0.2em] font-semibold text-background/70">
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
